import { useTranslation } from "react-i18next";

import { colors } from "#app/theme/v2/colors";
import { Text } from "#components/atoms/Typographies/Text";
import { Modal } from "#components/molecules/Modal/Modal";

type Props = {
  opened: boolean;
  onClose: () => void;
  onConfirm: () => void;
  loading?: boolean;
};

export const DeleteQuoteRequestLineConfirmationModal = ({
  opened,
  onClose,
  onConfirm,
  loading,
}: Props) => {
  const { t } = useTranslation();

  return (
    <Modal
      opened={opened}
      onClose={onClose}
      title={t("quoteRequestV2.deleteLine.title")}
      closeText={t("common.cancel")}
      primaryText={t("quoteRequestV2.deleteLine.confirm")}
      primaryVariant="destructive"
      primaryLoading={loading}
      onPrimary={onConfirm}
    >
      <Text size="small" color={colors.text.secondaryDefault}>
        {t("quoteRequestV2.deleteLine.body")}
      </Text>
    </Modal>
  );
};
